'use client';

import { useEffect, useState } from "react";
import Image from "next/image";
import styles from "./PhotographerMedias.module.css";
import DropdownTags from "../DropdownTags/DropdownTags";
import BottomAside from "../BottomAside/BottomAside";
import ContactForm from "../ContactForm/ContactForm";

export default function PhotographerMedias({ photographer, medias }) {
    const [totalLikes, setTotalLikes] = useState("");
    const [mediaLikes, setMediaLikes] = useState(
        medias.map((media) => ({ id: media.id, likes: media.likes, liked: false }))
    );
    const [sortedMedias, setSortedMedias] = useState(medias);
    const [sortOption, setSortOption] = useState("Popularité");

    // total likes
    useEffect(() => {
        const total = mediaLikes.reduce((sum, media) => sum + media.likes, 0);
        setTotalLikes(total);
    }, [mediaLikes]);

    // gestion du tri
    const handleSortChange = (option) => {
        setSortOption(option);

        const sorted = [...sortedMedias].sort((a, b) => {
            if (option === "Popularité") return b.likes - a.likes;
            if (option === "Date") return new Date(b.date) - new Date(a.date);
            if (option === "Titre") return a.title.localeCompare(b.title);
            return 0;
        });

        setSortedMedias(sorted);
    };

    // likes déjà likés depuis localStorage
    useEffect(() => {
        const savedLikes = JSON.parse(localStorage.getItem("likedMedias") || "[]");
        setMediaLikes((prev) =>
            prev.map((m) =>
                savedLikes.includes(m.id) ? { ...m, liked: true } : m
            )
        );
    }, []);

    const toggleLike = async (id) => {
        const current = mediaLikes.find((media) => media.id === id);
        const liked = !current.liked;

        setMediaLikes((prev) =>
            prev.map((media) =>
                media.id === id
                ? {
                    ...media,
                    liked: !media.liked,
                    likes: media.liked ? media.likes - 1 : media.likes + 1,
                    }
                : media
            )
        );

        const savedLikes = JSON.parse(localStorage.getItem("likedMedias") || "[]");
        let updatedLikes;

        if (liked) {
            updatedLikes = [...savedLikes, id];
        } else {
            updatedLikes = savedLikes.filter((mediaId) => mediaId !== id);
        }

        localStorage.setItem("likedMedias", JSON.stringify(updatedLikes));

        await fetch(`/api/media/${id}/like`, {
            method: "PATCH",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ liked }),
        });
    };

    return (
        <>
            <DropdownTags
                sortBy={sortOption}
                onChange={handleSortChange}
            />

            <section className={styles.mediasGrid}>
                {sortedMedias.map((media) => {
                    const state = mediaLikes.find((m) => m.id === media.id);
                    return (
                        <article key={media.id} className={styles.media}>
                            {media.image ? (
                                <Image
                                    src={"/assets/" + media.image}
                                    width={450}
                                    height={450}
                                    alt=""
                                    className={styles.mediaPicture}
                                />
                            ) : (
                                <video
                                    width={450}
                                    height={450}
                                    src={"/assets/" + media.video}
                                    controls
                                    className={styles.mediaPicture}
                                />
                            )}

                            <div className={styles.mediaContent}>
                                <p className={styles.mediaTitle}>{media.title}</p>
                                <button
                                    className={`${styles.mediaLikes} ${state.liked ? styles.liked : ""}`}
                                    onClick={() => toggleLike(media.id)}
                                >
                                    <p>{state.likes}</p>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        fill={"#901C1C"}
                                        className={styles.heartIcon}
                                    >
                                        <path d="M241 87.1l15 20.7 15-20.7C296 52.5 336.2 32 378.9 32 452.4 32 512 91.6 512 165.1l0 2.6c0 112.2-139.9 242.5-212.9 298.2-12.4 9.4-27.6 14.1-43.1 14.1s-30.8-4.6-43.1-14.1C139.9 410.2 0 279.9 0 167.7l0-2.6C0 91.6 59.6 32 133.1 32 175.8 32 216 52.5 241 87.1z"/>
                                    </svg>
                                </button>
                            </div>
                        </article>
                    );
                })}
            </section>
            <ContactForm 
                name={photographer.name}
            />
            <BottomAside 
                likes={totalLikes}
                price={photographer.price}
            />
        </>
    );
}
